import { Button, IconCommunicationInformation, Text } from "@twinkltech/web-ui";

export const CurriculumAccessTogglePrompt = ({
  onCancel,
  onConfirm,
}: {
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-4 bg-neutral-100 p-200 rounded-2xl mt-6">
        <IconCommunicationInformation className="w-10" />
        <Text as="p" className="m-0! leading-tight" variant="base-medium">
          Are you sure? Once saved, access cannot be reverted back to Private?
        </Text>
      </div>
      <div className="flex gap-2 justify-end">
        <Button size="sm" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="sm" variant="secondary" onClick={onConfirm}>
          Yes, Understood
        </Button>
      </div>
    </div>
  );
};
